import { Actions } from '@/components/atoms/EmptyState/Actions';
import { Container } from '@/components/atoms/EmptyState/Container';
import { Message } from '@/components/atoms/EmptyState/Message';
import { Title } from '@/components/atoms/EmptyState/Title';

export const EmptyState = {
  Container,
  Title,
  Message,
  Actions,
};
